var styleDataHash = 'd46b5bee';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";.EdpcJ,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.lsTpQ{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px}[dir] .lsTpQ{background:transparent;border:0;cursor:pointer;margin:0;padding:4px}[dir] .lsTpQ:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.lsTpQ.Xs7pM{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .lsTpQ.Xs7pM{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-tuple,2,97,255)),.1)}.lsTpQ.Xs7pM svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.lsTpQ:disabled{opacity:.4}[dir] .lsTpQ:disabled{cursor:default}[dir] .lsTpQ.w2ZvV:not(.Xs7pM):hover{background-color:unset}.lsTpQ:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.MWN9M{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.MWN9M.dOgvl{height:32px;min-width:32px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "EdpcJ",
  "toggleButtonWrapper": "lsTpQ",
  "active": "Xs7pM",
  "mobileToggleButtonWrapper": "w2ZvV",
  "toggleButton": "MWN9M",
  "mobileToggleButton": "dOgvl"
};